/* eslint-disable camelcase */
import { kea } from 'kea'
import PropTypes from 'prop-types'
import { put, call } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import axios from 'axios'
import ResultsLogic from 'containers/Results/logic'
import FilterLogic from 'containers/Filters/logic'
import ProfileLogic from 'containers/CompanyProfile/logic'
import AppLogic from 'containers/App/logic'
import { API_BASE_URL, ADESION_URL, isEnterprise, isAdvanced } from 'config'
import mapValues from 'lodash/mapValues'
import omit from 'lodash/omit'
import { CONTACTS, CONTACT_HOUR, BILLING_ADDRESS, DIRECT_DEBIT, ELETRONIC_BILLING, TARIFF, CYCLE, TIER } from 'components/TariffSubscribeForm/data'

const ENTITIES_ENDPOINT = `${API_BASE_URL}/public/entity/`
const POSTAL_ENDPOINT = `${API_BASE_URL}/public/postal-code/`
const SUBSCRIBE_PRICE_LIST_ENDPOINT = `${ADESION_URL}/public/subscribe-price-list/`

const DISTRICTS_ENDPOINT = `${API_BASE_URL}/public/district/`
const MUNICIPALITIES_ENDPOINT = `${API_BASE_URL}/public/municipality/`

const ENTREPRISE_PROPS = {
  companyName: { value: '', valid: false },
  companyCae: { value: '', valid: false },
  companyPhoneNumber: { value: '', valid: false },
  companyEmail: { value: '', valid: false },
  phone: { value: '', valid: false },
  email: { value: '', valid: false },
  legalBi: { value: '', valid: false },
  nif: { value: '', valid: false },
  name: { value: '', valid: false },
  surname: { value: '', valid: false },
  contact: { value: 'e', valid: false, designation: CONTACTS },
  contact_time: { value: '', valid: false, designation: CONTACT_HOUR }
}

const NORMAL_PROPS = {
  name: { value: '', valid: false },
  surname: { value: '', valid: false },
  nif: { value: '', valid: false },
  email: { value: '', valid: false },
  phone: { value: '', valid: false },
  contact: { value: 'e', valid: false, designation: CONTACTS },
  contact_time: { value: '', valid: false, designation: CONTACT_HOUR }
}

const DEFAULT_PROPS = {
  personal: isEnterprise ? ENTREPRISE_PROPS : NORMAL_PROPS,

  billing: {
    postalCode: { value: '', valid: false },
    postalExtension: { value: '', valid: false },
    street: { value: '', valid: false },
    door: { value: '', valid: false },
    floor: { value: '', valid: false },
    district: { value: '', valid: false, designation: 'd' },
    municipality: { value: '', valid: false, designation: 'm' },
    billingAddress: { value: 'e', valid: false, designation: BILLING_ADDRESS },
    directDebit: { value: 'd', valid: false, designation: DIRECT_DEBIT },
    electronicBilling: { value: 'e', valid: false, designation: ELETRONIC_BILLING },
    billingPostalCode: { value: '', valid: false },
    billingPostalExtension: { value: '', valid: false },
    billingStreet: { value: '', valid: false },
    billingDoor: { value: '', valid: false },
    billingFloor: { value: '', valid: false },
    billingDistrict: { value: '', valid: false, designation: 'd' },
    billingMunicipality: { value: '', valid: false, designation: 'bm' }
  },

  electric: {
    currentEntityElectric: { value: '', valid: false, designation: 'ee' },
    cpe: { value: '', valid: false },
    potency: { value: '', valid: false },
    tariff: { value: '', valid: false, designation: TARIFF },
    cycle: { value: '', valid: false, designation: CYCLE }
  },

  gas: {
    currentEntityGas: { value: '', valid: false, designation: 'eg' },
    cui: { value: '', valid: false },
    tier: { value: '', valid: false, designation: TIER }
  },

  confirm: {
    allowDataSharing: { value: false, valid: false }
  }
}

export default kea({
  connect: {
    actions: [
      ResultsLogic, [
        'fetchTariffInfo',
        'setTariffInfo'
      ]
    ],
    props: [
      ResultsLogic, [
        'tariffInfo',
        'userProfile'
      ],
      FilterLogic, [
        'filters'
      ],
      AppLogic, [
        'values',
        'userLoggedIn',
        'translations'
      ],
      ProfileLogic, [
        'data'
      ]
    ]
  },
  actions: () => ({
    fetchEntities: () => ({}),
    fetchPostalInfo: (code, extension, type) => ({ code, extension, type }),
    fetchMunicipality: (id) => ({ id }),
    setMunicipality: (municipality, type) => ({ fetched: { value: municipality, type } }),
    setPostalInfo: (postalInfo, type) => ({ postalInfo, type }),
    setEntities: (entities) => ({ entities }),
    setEntitiesError: (message) => ({ message }),
    setFetchError: (message) => ({ message }),
    setFormData: (formData) => ({ formData }),
    submitForm: (form) => ({ form }),
    setAdhesionResponse: (data) => ({ data }),
    setAdhesionError: (error) => ({ error }),
    reset: () => ({}),
    setInvalid: (invalid) => ({ invalid }),
    recheckValids: () => ({}),
    setFirstSet: firstSet => ({ firstSet }),

    /* SETTING */
    setDistricts: (districts) => ({ districts }),
    setMunicipalities: (municipalities) => ({ municipalities }),
    setBillingMunicipalities: (municipalities) => ({ municipalities }),
    setError: (error) => ({ error }),

    /* FETCHING */
    fetchDistrictsTrigger: () => ({}),
    fetchMunicipalitiesTrigger: (id, type) => ({ id, type })
  }),
  reducers: ({ actions }) => ({
    entities: [[], PropTypes.array, {
      [actions.setEntities]: (state, payload) => ([...payload.entities])

    }],
    postalInfo: [null, PropTypes.object, {
      [actions.setPostalInfo]: (state, payload) => ([...payload.postalInfo, payload.type]),
      [actions.reset]: () => null
    }],
    municipality: [null, PropTypes.object, {
      [actions.setMunicipality]: (state, payload) => payload.fetched,
      [actions.reset]: () => null
    }],
    districts: [[], PropTypes.array, {
      [actions.setDistricts]: (_, payload) => payload.districts
    }],
    municipalities: [[], PropTypes.array, {
      [actions.setMunicipalities]: (_, payload) => payload.municipalities
    }],
    billingMunicipalities: [[], PropTypes.array, {
      [actions.setBillingMunicipalities]: (_, payload) => payload.municipalities
    }],
    formData: [DEFAULT_PROPS, PropTypes.object, {
      [actions.setFormData]: (state, payload) => ({ ...state, ...payload.formData }),
      [actions.recheckValids]: (_, payload) => {
        let current = { ..._ }

        current = mapValues(current, (list1, key1) => {
          return mapValues(list1, (item, key) => {
            return { ...item, valid: false }
          })
        })

        return current
      },
      [actions.reset]: () => DEFAULT_PROPS,
      [actions.setInvalid]: (_, payload) => {
        let current = { ..._ }
        const key = Object.keys(payload.invalid)[0]
        const list = payload.invalid[key]

        current = mapValues(current, (list1, key1) => {
          return mapValues(list1, (item, key) => {
            return { ...item, valid: false }
          })
        })

        mapValues(list, (valid, valueKey) => {
          current[key][valueKey].valid = valid
        })

        return current
      }
    }],
    adhesionResponse: [null, PropTypes.object, {
      [actions.setAdhesionResponse]: (state, payload) => payload.data,
      [actions.reset]: () => null
    }],

    adhesionError: [null, PropTypes.object, {
      [actions.setAdhesionError]: (state, payload) => payload.error,
      [actions.reset]: () => null
    }],

    loadingAddress: [false, PropTypes.bool, {
      [actions.fetchPostalInfo]: () => true,
      [actions.setPostalInfo]: () => false
    }],

    addressNotFound: [false, PropTypes.bool, {
      [actions.fetchPostalInfo]: () => false,
      [actions.setPostalInfo]: () => false,
      [actions.setFetchError]: () => true
    }],

    firstSet: [true, PropTypes.bool, {
      [actions.setFirstSet]: (_, payload) => payload.firstSet,
      [actions.reset]: () => true
    }]
  }),
  selectors: ({ selectors }) => ({
    electricEntities: [
      () => [selectors.entities],
      entities => entities.filter(entity => entity.offer_types[0].order !== 3),
      PropTypes.array
    ],
    gasEntities: [
      () => [selectors.entities],
      entities => entities.filter(entity =>
        entity.offer_types.length !== 1 && entity.offer_types[0].order !== 2),
      PropTypes.array
    ]
  }),
  takeLatest: ({ actions, workers }) => ({
    [actions.fetchEntities]: workers.fetchEntities,
    [actions.fetchPostalInfo]: workers.fetchPostalInfo,
    [actions.submitForm]: workers.submitForm,
    [actions.fetchDistrictsTrigger]: workers.fetchDistricts
  }),
  takeEvery: ({ actions, workers }) => ({
    [actions.fetchMunicipalitiesTrigger]: workers.fetchMunicipalities
  }),
  start: function * () {
    const {
      fetchEntities,
      fetchTariffInfo,
      fetchDistrictsTrigger,
      fetchMunicipalitiesTrigger,
      setFormData
    } = this.actions

    const user = yield AppLogic.get('userLoggedIn')
    const formData = yield this.get('formData')

    if (user) {
      const name = user.user.name.split(' ')
      const hasSurName = name.length >= 2
      const surname = (hasSurName && name[name.length - 1]) || ''
      const phone = (user.phone_number && user.phone_number.replace('+351', '')) || ''

      const fillForm = {
        personal: {
          ...formData.personal,
          name: { value: name[0], valid: false },
          surname: { value: surname, valid: false },
          nif: { value: user.tax_id, valid: false },
          email: { value: user.user.email || '', valid: false },
          phone: { value: phone, valid: false },
          contact: { value: 'e', valid: false, designation: CONTACTS },
          contact_time: { value: '', valid: false, designation: CONTACT_HOUR }
        },
        billing: {
          ...formData.billing,
          street: { value: user.address, valid: false },
          municipality: { value: user.municipality, valid: false, designation: 'm' },
          district: { value: user.district, valid: false, designation: 'd' },
          postal_code: { value: user.postal_code, valid: false },
          billingStreet: { value: user.address, valid: false },
          billingMunicipality: { value: user.municipality, valid: false, designation: 'bm' },
          billingDistrict: { value: user.district, valid: false, designation: 'd' },
          billing_postal_code: { value: user.postal_code, valid: false }
        }
      }

      yield put(fetchMunicipalitiesTrigger(user.district, 'district'))
      yield put(fetchMunicipalitiesTrigger(user.district, ''))

      try {
        const post = yield call(axios.get, `${API_BASE_URL}/public/postal-code/${user.postal_code}/`)
        fillForm.billing.billingPostalCode = { value: post.data.postal_code, valid: false }
        fillForm.billing.billingPostalExtension = { value: post.data.postal_code_extension, valid: false }
        fillForm.billing.postalCode = { value: post.data.postal_code, valid: false }
        fillForm.billing.postalExtension = { value: post.data.postal_code_extension, valid: false }
      } catch (error) {
        console.log(error)
      }

      yield put(setFormData(fillForm))
    }

    yield put(fetchEntities())
    yield put(fetchTariffInfo(this.props.tariff))
    yield put(fetchDistrictsTrigger())
  },
  workers: {
    * fetchEntities (action) {
      const { setEntities, setEntitiesError } = this.actions

      try {
        const entities = yield call(axios.get, ENTITIES_ENDPOINT)
        yield put(setEntities(entities.data.results))
      } catch (error) {
        yield put(setEntitiesError(error))
      }
    },

    * fetchPostalInfo ({ payload }) {
      const { setPostalInfo, setFetchError, setFormData } = this.actions
      try {
        const postalInfo = yield call(axios.get, POSTAL_ENDPOINT, { params: { postal_code: payload.code, postal_code_extension: payload.extension } })
        yield put(setPostalInfo(postalInfo.data.results, payload.type))
        const { artery_type, prep1, artery_name, prep2, artery_title, municipality, district, id } = postalInfo.data.results[0]
        const billing = { ...this.props.formData.billing }
        const street = [artery_type, prep1, artery_title, prep2, artery_name].filter(n => n).join(' ')
        const mun = municipality
        const dist = district

        if (payload.type === 'normal') {
          billing.street = { ...billing.street, value: street }
          billing.municipality = { ...billing.municipality, value: mun }
          billing.district = { ...billing.district, value: dist }
          billing.postal_code = { ...billing.postal_code, value: id }
        } else {
          billing.billingStreet = { ...billing.billingStreet, value: street }
          billing.billingMunicipality = { ...billing.billingMunicipality, value: mun }
          billing.billingDistrict = { ...billing.billingDistrict, value: dist }
          billing.billing_postal_code = { ...billing.postal_code, value: id }
        }
        yield put(setFormData({...this.props.formData, billing}))
        yield delay(800)
        yield put(setFormData({...this.props.formData, billing}))
      } catch (error) {
        yield put(setFetchError(error))
      }
    },

    * submitForm ({ payload }) {
      const { setAdhesionResponse, setAdhesionError } = this.actions
      const { formData: { billing: { postalCode, postalExtension, billingPostalCode, billingPostalExtension } } } = this.props
      const userCPEandCUI = yield ResultsLogic.get('userProfile')
      let form = {}
      Object.keys(payload.form).forEach(key => {
        form[key] = payload.form[key]
      })
      const arrayBillings = ['billing_district', 'billing_door', 'billing_floor', 'billing_municipality', 'billing_street']
      /** If billing_address is "e", thats means equal, billing values needs to be empty */
      if (form.billing_address === 'e') {
        Object.keys(form).forEach(key => {
          if(!!(arrayBillings.find((value) => value === key))){
            form[key] = ""
          }
        })
      }

      /** If NIF is empty, send nif of user */
      if (!form.tax_id) {
        if (this.props.formData.personal && this.props.formData.personal.nif) {
          form.tax_id = this.props.formData.personal.nif.value
        }
      }

      /** If User has CPE added, send to API */
      if (!form.cpe) {
        if(userCPEandCUI && userCPEandCUI.cpe) {
          form.cpe = userCPEandCUI.cpe
        }
      }

      /** If User has CUI added, send to API */
      if (!form.cui) {
        if(userCPEandCUI && userCPEandCUI.cui) {
          form.cui = userCPEandCUI.cui
        }
      }

      if (form.phone_number) {
        form.phone_number = `+351${form.phone_number}`
      } else {
        delete form.phone_number
      }

      if (form.company_phone_number) {
        form.company_phone_number = `+351${form.company_phone_number}`
      } else {
        delete form.company_phone_number
      }

      // Set form type
      form.type = 'p'
      if (isEnterprise) {
        form.type = 'e'
      }

      try {
        if (!form.postal_code && postalCode.value && postalExtension.value) {
          const res = yield call(axios.get, POSTAL_ENDPOINT, { params: { postal_code: postalCode.value, postal_code_extension: postalExtension.value } })
          form.postal_code = res.data.results.length && res.data.results[0].id
        }

        if (form.billing_address === 'd' && !form.billing_postal_code && billingPostalCode.value && billingPostalExtension.value) {
          const res = yield call(axios.get, POSTAL_ENDPOINT, { params: { postal_code: billingPostalCode.value, postal_code_extension: billingPostalExtension.value } })
          form.billing_postal_code = res.data.results.length && res.data.results[0].id
        }

        if (form.time_cycle === 's') {
          form = omit(form, ['price_list_cycle'])
        }

        form.requires_cui_cpe = isAdvanced

        const result = yield call(axios.post, SUBSCRIBE_PRICE_LIST_ENDPOINT, form)
        const { data } = result
        yield put(setAdhesionResponse(data))
      } catch (error) {
        if (error.response.data &&
          error.response.status === 400 &&
        error.response.data.cui && error.response.data.cpe) {
          error.response.data.cuicpe = ''
          delete error.response.data.cui
          delete error.response.data.cpe
        }
        if (error.response.status !== 400) {
          error.response.data = 'error'
        }
        yield put(setAdhesionError(error))
      }
    },

    * fetchMunicipalities ({ payload }) {
      const { setMunicipalities, setBillingMunicipalities, setError } = this.actions
      const { id, type } = payload

      try {
        const res = yield call(axios.get, MUNICIPALITIES_ENDPOINT, { params: { limit: 100, district: id } })
        const action = type === 'district' ? setMunicipalities : setBillingMunicipalities
        yield put(action(res.data.results))
      } catch (error) {
        yield put(setError(error))
      }
    },

    * fetchDistricts () {
      const { setDistricts, setError } = this.actions

      try {
        const res = yield call(axios.get, DISTRICTS_ENDPOINT, { params: { limit: 100 } })
        yield put(setDistricts(res.data.results))
      } catch (error) {
        yield put(setError(error))
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/containers/TariffSubscribeModal/logic.js